import type { Feedback, FeedbackKind, Reporter } from "./support-client";

/**
 * The helpdesk has no category field, so the first line is what the team
 * filters and tags on. Change a label only together with any workflow that
 * matches it.
 */
const KIND_LABELS: Record<FeedbackKind, string> = {
  bug: "Bug report",
  feature: "Feature request",
  other: "Other feedback",
};

/** A line break in a value would start a header line of its own. */
function oneLine(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

/**
 * A short header, a blank line, then the attorney's words as written. The
 * helpdesk takes text only, so the header is where the context has to go,
 * the sender's HubSpot contact included when they have one, and what the
 * screen knew when it asked for the report, a line each.
 */
export function formatFeedbackMessage(
  feedback: Feedback,
  reporter: Reporter,
): string {
  const contact = reporter.hubspotContactId;
  return [
    `Type: ${KIND_LABELS[feedback.kind]}`,
    `Browser: ${oneLine(feedback.browser)}`,
    `Device OS: ${oneLine(feedback.os)}`,
    `Screen: ${oneLine(feedback.screen)}`,
    ...(contact ? [`HubSpot contact: ${oneLine(contact)}`] : []),
    ...Object.entries(feedback.context ?? {}).map(
      ([name, value]) => `Debug: ${oneLine(name)}: ${oneLine(value)}`,
    ),
    "",
    feedback.text.trim(),
  ].join("\n");
}
